import pipeline from '@/pipeline';
import { RouterParams } from './interfaces/IRouter';

const hasCityInStoreMiddleware = ({ next, router }: RouterParams) => {
  const selectedCity = router?.app?.$store?.getters?.selectedCity;

  if (!selectedCity?.city || !selectedCity?.state) {
    pipeline.prev();
  }

  return next();
};

export { hasCityInStoreMiddleware };
